import { SECTION_FRAGMENT } from './SectionFragment'

export const SHOPPING_FEED_FRAGMENT = `{
  shoppingFeed(input: { feedType: $feedType, origin: $origin, isPageLayout: $isPageLayout }) {
    sections ${SECTION_FRAGMENT}
  }
}`

const KEVEL_ADS_FRAGMENT = `
  kevelAds(input: { pageIdentifier: "SHOPPING_PAGE" }) {
    id
    templateName
    clickUrl
    impressionUrl
    impressionStrategy
    thirdPartyTrackingUrls
    fpti {
      tag
      value
    }
    asset {
      height
      width
      primaryImageUrl
      secondaryImageUrl
      backgroundImageUrl
      logoUrl
      title
      subtitle
      longDescription
      merchantName
      ctaText
      uiStyles {
        theme
        backgroundColor
      }
    }
  }
`

export const SHOPPING_FEED_WITH_ADS_FRAGMENT = `{
  shoppingFeed(input: { feedType: $feedType, origin: $origin, isPageLayout: $isPageLayout }) {
    sections ${SECTION_FRAGMENT}
  }
  ${KEVEL_ADS_FRAGMENT}
}`
